import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ru from './locales/ru.json';
import en from './locales/en.json';

const savedLanguage = (() => {
  try {
    return localStorage.getItem('polka_language') || 'ru';
  } catch {
    return 'ru';
  }
})();

i18n.use(initReactI18next).init({
  resources: {
    ru: { translation: ru },
    en: { translation: en }
  },
  lng: savedLanguage,
  fallbackLng: 'ru',
  interpolation: {
    escapeValue: false
  }
});

i18n.on('languageChanged', (lng) => {
  try {
    localStorage.setItem('polka_language', lng);
  } catch {
    // ignore
  }
});

export default i18n;